'use client';

import type { RefObject } from 'react';
import type { TooltipProps } from '../TooltipProps';

/**
 * Calculate new positioning of tooltip if it is out of the viewport
 * @param tooltipContentRef reference to tooltip content
 * @param prevPositioning previous positioning of tooltip
 * @returns new positioning of tooltip
 */
export function calculateNewPositioning(
  tooltipContentRef: RefObject<HTMLSpanElement | null>,
  prevPositioning: NonNullable<TooltipProps['positioning']>,
) {
  const {
    left = 0,
    right = 0,
    top = 0,
    bottom = 0,
  } = tooltipContentRef.current?.getBoundingClientRect() || {};
  const { innerWidth, innerHeight } = window;
  let finalPositioning = prevPositioning;
  // fixing horizontal position
  if (right > innerWidth && finalPositioning?.includes('start')) {
    finalPositioning = finalPositioning.replace('start', 'end') as typeof prevPositioning;
  } else if (left < 0 && finalPositioning?.includes('end')) {
    finalPositioning = finalPositioning.replace('end', 'start') as typeof prevPositioning;
  }

  // fixing vertical position
  if (bottom > innerHeight && finalPositioning?.includes('top')) {
    finalPositioning = finalPositioning.replace('top', 'bottom') as typeof prevPositioning;
  } else if (top < 0 && finalPositioning?.includes('bottom')) {
    finalPositioning = finalPositioning.replace('bottom', 'top') as typeof prevPositioning;
  }

  // return combined result of fixed horizontal and vertical positioning
  return finalPositioning;
}
